// extracted by mini-css-extract-plugin
export default {"wrapper":"Tooltip_wrapper__dmIof","box":"Tooltip_box__bX5x8","wide":"Tooltip_wide__HI7hv"};